<template lang="pug">
  div
    content-loader(:height="7", v-if="alert.loading")
    b-card.table-card(v-else-if="rentals && rentals.length > 0")
      p(v-if='rentals.length < 1') No rentals
      b-table#tblLiveRentals(v-else="", :items="rentals", :fields="fields", sort-icon-left, sort-by="status", :sort-desc="true", responsive, borderless, hover)
        template(v-slot:cell(compStatus)="row")
            b-badge(variant="light") {{ row.item.status }}
    nothing(v-else="")
</template>

<script>

import { ContentLoader } from 'vue-content-loader';
import standardMix from '@/mixins/standardMix';
import { apiService } from '@/services';

export default {
  name: 'Rental',
  components: {
    ContentLoader,
  },
  mixins: [standardMix],
  data() {
    return {
      rentals: [],
      currentPage: 1,
      polling: null,
      lastUpdate: '',
      fields: [
        { key: 'art_title', label: 'Piece' },
        { key: 'date_start_pretty', label: 'From' },
        { key: 'date_end_pretty', label: 'To' },
        { key: 'compStatus', label: 'Status' },
      ],
    };
  },
  computed: {
    totalRows() {
      return this.rentals.length;
    },
  },
  methods: {
    refreshData() {
      const d = new Date();
      this.lastUpdate = `${d.getUTCHours() + 2}:${d.getUTCMinutes()}:${d.getUTCSeconds()}`;
      this.getResource('races');
    },
  },
  async created() {
    this.loading();
    this.rentals = await apiService.getRentals(this.profileId, 'active');
    this.clear();
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/RentalsLive.vue